// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","links":"contextualLinks-module--links--1YTZH","links__description":"contextualLinks-module--links__description--3OfQc"};